import React, { useState } from 'react';
import { InputPrefix, TextBox } from '@progress/kendo-react-inputs';
import { logoutIcon, searchIcon } from '@progress/kendo-svg-icons';
import { SvgIcon } from '@progress/kendo-react-common';
import { Button, ButtonGroup } from '@progress/kendo-react-buttons';
import "./CampaignList.css";
import CampaignListCard from './CampaignListCard';
import AddCampaigns from '../CampaignHome/AddCampaigns/AddCampaigns';
import BuildIdLogo from "../../../Assets/Build-ID-Transparent 3.png"

const CampaignList = ({
    setCampaignStatus,
    campaignStatus,
    campaignSearchQuery = "", // Ensure it's always a string
    setCampaignSearchQuery,
    ...props
}) => {
    const [addCampaignVisible, setAddCampaignVisible] = React.useState(false);

    const toggleAddCampaignsDialog = () => {
        setAddCampaignVisible((prevState) => !prevState); // Properly toggle the state
    };

    const handleFilterClick = (filter) => {
        setCampaignStatus(filter)
    };

    const handleCardClick = (id) => {
        localStorage.setItem("activeCampaignId", id)

        props.setClickedCardId(id); // Set clicked card ID
    };

    const handleOnSearch = React.useCallback((event) => {
        setCampaignSearchQuery(event.target.value);
    }, [setCampaignSearchQuery]);


    //Auto Trigger if there are no campaigns
    React.useEffect(() => {
        if (props.campaignList.length === 0) {
            setAddCampaignVisible(true)
        }
    }, []);

    let handleLogout = () => {
        localStorage.clear();
        window.location.href = "/";
    }

    return (
        <div>
            <>
                <div className="campaign-list-header">
                    <img height="48px" src={BuildIdLogo} alt="Build ID Logo" />

                    <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 0px 26px 0px" }}>
                        <div className="profile-card" >

                            <div>
                                <h2 style={{
                                    fontSize: '1.2em',
                                    fontWeight: 'normal',
                                    margin: 0
                                }}>
                                    {localStorage.getItem("firstName") + " " + localStorage.getItem("lastName")}
                                </h2>
                                <p style={{
                                    margin: 0,
                                    fontSize: '0.8em',
                                    color: "gray"
                                }}>{"Thermal Systems"}</p>
                            </div>

                            {/* Logout Button */}
                            <Button
                                style={{ marginLeft: "16px" }}
                                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                                onClick={handleLogout}
                                svgIcon={logoutIcon}
                            >

                            </Button>
                        </div>

                    </span>


                    <span style={{ display: "flex", gap: "12px" }}>

                        <TextBox
                            style={{ width: "70%" }}
                            value={props.campaignSearchQuery} // Bind input value
                            onChange={handleOnSearch} // Update state on input change
                            placeholder="Search"
                            prefix={() => (
                                <InputPrefix>
                                    <SvgIcon icon={searchIcon} disabled />
                                </InputPrefix>
                            )}
                        />


                        <Button
                            style={{ width: "120px" }}
                            themeColor={'primary'}
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                            onClick={toggleAddCampaignsDialog}
                        >
                            Add Campaign
                        </Button>
                    </span>

                    <div className="filter-button-group">
                        <ButtonGroup>
                            <Button
                                onClick={() => handleFilterClick("All")}
                                className={campaignStatus === "All" ? "active" : ""}
                            >
                                All
                            </Button>
                            <Button
                                onClick={() => handleFilterClick("Active")}
                                className={campaignStatus === "Active" ? "active" : ""}
                            >
                                Active
                            </Button>
                            <Button
                                onClick={() => handleFilterClick("Finished")}
                                className={campaignStatus === "Finished" ? "active" : ""}
                            >
                                Finished
                            </Button>
                            <Button
                                onClick={() => handleFilterClick("Pending")}
                                className={campaignStatus === "Pending" ? "active" : ""}
                            >
                                Pending
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
                <div className="campaign-list-ads-list">
                    {props.campaignList.length > 0 ? props.campaignList.map((ad) => (
                        <CampaignListCard
                            key={ad.id}
                            cardDetails={ad}
                            onClick={() => handleCardClick(ad.id)}
                            className={props.clickedCardId === ad.id ? "clicked-card" : ""}
                            campaignStatus={campaignStatus}
                            {...props}
                        />
                    )) : <div className="no-campaigns">No Campaigns Found</div>}
                </div>
            </>

            {addCampaignVisible && <AddCampaigns closeDialog={() => setAddCampaignVisible(false)}  {...props} />}

        </div>
    );
};

export default CampaignList;
